export const OutreachOrigin = {
  rjCommunicationSingle: 'rj-communication-single',
  rjCommunicationBulk: 'rj-communication-bulk',
  rjOutreach: 'rj-outreach',
} as const;

export type OutreachOriginValue = (typeof OutreachOrigin)[keyof typeof OutreachOrigin];
